import * as actionTypes from './actionTypes';

export const printing = ( ) => {
    return {
        type: actionTypes.PRINTING
    };
};

export const not_printing = () => {
    return {
        type: actionTypes.NOT_PRINTING
    };
};

export const printingStart = () => {
	return dispatch => {
	    dispatch(printing( ));
	};
};

export const printingStop = () => {
    return dispatch => {
	    dispatch(not_printing());
	}
};


// WEBPACK FOOTER //
// ./src/_store/actions/printing.js